import React, { useCallback, useEffect, useState } from 'react';
import MedicationsScreen from 'components/pharmacyMedications/Medications';
import AllergiesScreen from 'components/pharmacyMedications/Allergies';
import PageMedicalHistoryComplete from 'components/pharmacyMedications/PharmacyMedicationsComplete';
import PharmacyInformationScreen from 'components/pharmacyMedications/PharmacyInformation';
import { actionTypeOfMedicalHistory } from 'reducer/actionType';
import { useSelector } from 'react-redux';
import { NullableCommunique } from 'types/types';
import { RootState } from 'store/store';
import Header from 'components/common/header';
import useBeforeUnload from 'hooks/useBeforeUnload';
import PatientConsent from 'components/pharmacyMedications/PatientConsent';

function PharmacyMedicationsApp() {
  const totalPage = 4;
  const [currentPage, setCurrentPage] = useState(1);
  const [resultPage, setResultPage] = useState(false);
  useBeforeUnload(totalPage > currentPage);

  const communiqueData = useSelector(
    (state: RootState) => state.communique,
  ) as NullableCommunique;

  const nextOrSubmitButton = useCallback(
    (nextPage: number, submit?: boolean) => {
      if (submit) {
        setResultPage(true);
        setCurrentPage(100);
        return;
      }
      setCurrentPage(nextPage);
    },
    [],
  );

  const pageBackButton = (pageNumber: number) => {
    if (pageNumber <= 1) {
      return;
    }
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    if (!communiqueData?.sendForms?.dosespotConsentForm) {
      setCurrentPage(2);
    }
  }, [communiqueData]);

  return (
    <div
      className="app-page-container"
    >
      <Header
        currentPage={currentPage}
        totalPage={totalPage}
        onClickBackButton={pageBackButton}
        hasBackButton={currentPage > 2}
      />
      <div className="pt-36 pb-20 px-3">
        {currentPage === 1 && (
          <PatientConsent
            currentPage={1}
            nextPage={2}
            actionPage={actionTypeOfMedicalHistory.PATIENT_CONSENT}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}
        {currentPage === 2 && (
          <PharmacyInformationScreen
            currentPage={2}
            nextPage={3}
            actionPage={actionTypeOfMedicalHistory.PHARMACY_INFORMATION}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}
        {currentPage === 3 && (
          <MedicationsScreen
            currentPage={3}
            nextPage={4}
            actionPage={actionTypeOfMedicalHistory.MEDICATIONS}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}
        {currentPage === 4 && (
          <AllergiesScreen
            currentPage={4}
            nextPage={5}
            actionPage={actionTypeOfMedicalHistory.ALLERGIES}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}
        {resultPage && <PageMedicalHistoryComplete />}
      </div>
    </div>
  );
}

export default PharmacyMedicationsApp;
